import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _ModerateSession;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Table } from '@instructure/ui-table';
import { Button } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import { jsx } from '@instructure/emotion';
import { Page, QuizzesSpinner as Spinner, formatTimespan, IfFeature, Event } from '@instructure/quiz-core';
import t from '@instructure/quiz-i18n/es/format-message';
import { withI18nSupport, QUIZ_SUBMISSION_EVENT, SESSION_MANUAL_SUBMISSION_MODAL, withStyleOverrides, SESSION_STARTED_OR_RESUMED_EVENT } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import ManualSubmissionModal from './ManualSubmissionModal';
export var ModerateSession = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_ModerateSession = /*#__PURE__*/function (_withI18nSupport) {
  function ModerateSession() {
    var _this;
    _classCallCheck(this, ModerateSession);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ModerateSession, [].concat(args));
    _defineProperty(_this, "state", {
      isPolling: false
    });
    _defineProperty(_this, "openManualSubmissionModalOnClick", function () {
      _this.props.openModal(SESSION_MANUAL_SUBMISSION_MODAL);
    });
    _defineProperty(_this, "checkAutogradingStatus", function () {
      var status = _this.props.quizSession.status;
      if (status === 'autograding' || status === 'in_progress') {
        _this.pollAutogradingStatus();
      } else {
        _this.setState({
          isPolling: false
        });
        _this.props.addSuccess(t('Manual submission was successful.'));
      }
    });
    _defineProperty(_this, "pollAutogradingStatus", function () {
      // poll quiz session until status is not autograding/in_progress
      _this.props.getQuizSession(_this.props.quizSession.id);
      setTimeout(function () {
        _this.checkAutogradingStatus();
      }, 1000);
    });
    _defineProperty(_this, "handleSubmitAndPoll", function () {
      _this.setState({
        isPolling: true
      });
      _this.pollAutogradingStatus();
    });
    return _this;
  }
  _inherits(ModerateSession, _withI18nSupport);
  return _createClass(ModerateSession, [{
    key: "componentDidMount",
    value:
    // ============
    //  LIFECYCLE
    // ============

    function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.quizSessionId !== prevProps.quizSessionId) {
        this.fetchData();
      }
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this$props = this.props,
        getQuizSession = _this$props.getQuizSession,
        getQuizSessionEvents = _this$props.getQuizSessionEvents,
        getSessionItems = _this$props.getSessionItems,
        quizSessionId = _this$props.quizSessionId,
        quizSession = _this$props.quizSession,
        quizSessionEvents = _this$props.quizSessionEvents,
        sessionItemsLoaded = _this$props.sessionItemsLoaded;
      if (!quizSession.isLoaded()) {
        getQuizSession(quizSessionId);
      }
      if (!quizSessionEvents.size) {
        getQuizSessionEvents(quizSessionId);
      }
      if (!sessionItemsLoaded) {
        // NOTE: we fetch sessionItems so that we can render user responses
        getSessionItems(quizSessionId);
      }
    }

    // ============
    //   HELPERS
    // ============
  }, {
    key: "submittedEvent",
    value: function submittedEvent() {
      return this.props.quizSessionEvents.valueSeq().find(function (event) {
        return event.get('eventType') === QUIZ_SUBMISSION_EVENT;
      });
    }
  }, {
    key: "startTime",
    value: function startTime() {
      var firstEvent = this.props.quizSessionEvents.first();
      if (firstEvent) {
        return firstEvent.createdDate();
      }
    }
  }, {
    key: "endTime",
    value: function endTime() {
      // This isn't an endtime, it is a 'last seen time'
      var lastEvent = this.props.quizSessionEvents.last();
      if (lastEvent) {
        return lastEvent.createdDate();
      }
    }
  }, {
    key: "formattedDuration",
    value: function formattedDuration() {
      if (this.startTime() && this.endTime()) {
        return formatTimespan(this.startTime(), this.endTime());
      }
    }
  }, {
    key: "firstSessionStartEvent",
    value: function firstSessionStartEvent() {
      return this.props.quizSessionEvents.find(function (event) {
        return event.get('eventType') === SESSION_STARTED_OR_RESUMED_EVENT;
      });
    }
  }, {
    key: "footerText",
    value: function footerText() {
      var status = this.props.quizSession.status;
      if (this.submittedEvent()) {
        return t('Finished on {time} after {duration}', {
          time: this.formatDatetimeLong(this.endTime()),
          duration: this.formattedDuration()
        });
      } else if (status === 'in_progress') {
        return t('Session still in progress');
      } else {
        return jsx(React.Fragment, null);
      }
    }
  }, {
    key: "renderEvents",
    value:
    // ============
    //  RENDERING
    // ============

    function renderEvents() {
      var _this2 = this;
      return jsx(Table.Body, null, this.props.quizSessionEvents.toArray().map(function (event) {
        return jsx(Event, {
          event: event,
          key: event.get('createdAt'),
          startTime: _this2.startTime(),
          firstEvent: _this2.firstSessionStartEvent()
        });
      }));
    }
  }, {
    key: "renderTableHeader",
    value: function renderTableHeader() {
      return jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        width: 1,
        id: "moderate-session-elapsed-time"
      }, jsx("span", {
        "aria-hidden": "true",
        role: "presentation"
      }, t('Elapsed time')), jsx(ScreenReaderContent, null, t('Elapsed time since starting'))), jsx(Table.ColHeader, {
        width: "auto",
        id: "moderate-session-event-details"
      }, jsx("span", {
        "aria-hidden": "true",
        role: "presentation"
      }, t('Event details')), jsx(ScreenReaderContent, null, t('Details about the captured event')))));
    }
  }, {
    key: "renderHiddenHeader",
    value: function renderHiddenHeader() {
      return jsx(ScreenReaderContent, null, jsx(Heading, {
        level: "h2"
      }, t('Log of student taking events')));
    }
  }, {
    key: "renderManualSubmissionButton",
    value: function renderManualSubmissionButton() {
      return jsx(View, {
        as: "div",
        margin: "small 0 0 0"
      }, jsx(IfFeature, {
        name: "manual_submission"
      }, jsx("div", null, jsx(Button, {
        onClick: this.openManualSubmissionModalOnClick,
        "data-automation": "session-manual-submission-modal-open"
      }, t('Submit This Attempt')), jsx(ManualSubmissionModal, {
        studentName: this.props.studentName,
        quizSessionId: this.props.quizSession.id,
        handleSubmitAndPoll: this.handleSubmitAndPoll,
        afterSubmit: this.props.handleFocus
      }))));
    }
  }, {
    key: "renderManualSubmissionButtonIfInProgress",
    value: function renderManualSubmissionButtonIfInProgress() {
      if (this.props.quizSession && this.props.quizSession.inProgress()) {
        return this.renderManualSubmissionButton();
      }
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      if (this.props.isFetching || this.state.isPolling) {
        return jsx(Spinner, null);
      }
      if (!this.props.quizSessionEvents.size) {
        return jsx("div", null, jsx("div", null, jsx(Text, {
          color: "primary"
        }, t('There are no session events to display yet.'))), this.renderManualSubmissionButtonIfInProgress());
      }
      return jsx("div", {
        className: "fs-mask"
      }, this.renderHiddenHeader(), jsx("div", {
        css: this.props.styles.startTime
      }, jsx(Heading, {
        level: "h4",
        as: "h3",
        color: "primary"
      }, t('Began {time}', {
        time: this.formatDatetimeLong(this.startTime())
      }))), jsx(Table, {
        hover: true,
        caption: t('Log of student taking events')
      }, this.renderTableHeader(), this.renderEvents()), jsx("div", {
        css: this.props.styles.endTime
      }, jsx(Heading, {
        level: "h4",
        as: "h3",
        color: "primary"
      }, this.footerText())), this.renderManualSubmissionButtonIfInProgress());
    }
  }, {
    key: "render",
    value: function render() {
      return jsx(Page, null, jsx("div", {
        css: this.props.styles.page
      }, this.renderContent()));
    }
  }]);
}(withI18nSupport(Component)), _defineProperty(_ModerateSession, "displayName", 'ModerateSession'), _defineProperty(_ModerateSession, "componentId", "Quizzes".concat(_ModerateSession.displayName)), _defineProperty(_ModerateSession, "propTypes", {
  addSuccess: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  getQuizSession: PropTypes.func.isRequired,
  quizSessionId: PropTypes.string.isRequired,
  getQuizSessionEvents: PropTypes.func.isRequired,
  getSessionItems: PropTypes.func.isRequired,
  quizSessionEvents: ImmutablePropTypes.list.isRequired,
  sessionItemsLoaded: PropTypes.bool.isRequired,
  locale: PropTypes.string,
  timezone: PropTypes.string,
  openModal: PropTypes.func.isRequired,
  studentName: PropTypes.string,
  quizSession: ImmutablePropTypes.record.isRequired,
  handleFocus: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_ModerateSession, "defaultProps", {
  handleFocus: Function.prototype,
  locale: null,
  timezone: null,
  studentName: null
}), _defineProperty(_ModerateSession, "contextTypes", {
  locale: PropTypes.string,
  timezone: PropTypes.string
}), _ModerateSession)) || _class);
export default ModerateSession;